import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import uiLibCSS from "@virkesborsen/ui-component-library/dist/styles/tailwind.raw.js";
import tailwindCSS from "../../styles/tailwind.css";

export const TailwindWrapper = ({ children }) => {
  const hostRef = useRef(null);
  const [shadowRoot, setShadowRoot] = useState(null);

  useEffect(() => {
    if (hostRef.current && !shadowRoot) {
      setShadowRoot(hostRef.current.attachShadow({ mode: "open" }));
    }
  }, [shadowRoot]);

  useEffect(() => {
    if (shadowRoot) {
      if (!shadowRoot.querySelector("style[data-uilib]")) {
        let style = document.createElement("style");
        style.setAttribute("data-uilib", "ui-lib");
        style.textContent = uiLibCSS;
        shadowRoot.appendChild(style);
      }

      if (!shadowRoot.querySelector("style[data-tailwind]")) {
        const style = document.createElement("style");
        style.setAttribute("data-tailwind", "tailwind2");
        style.textContent = tailwindCSS;
        shadowRoot.appendChild(style);
      }
    }
  }, [shadowRoot]);

  return (
    <div style={{ display: "contents" }} ref={hostRef}>
      {shadowRoot && ReactDOM.createPortal(children, shadowRoot)}
    </div>
  );
};
